import { Controller } from "@hotwired/stimulus"
import { allDevicesStore } from "../../stores/devices/all_devices_store"
import { useStore } from "stimulus-store"

// Connects to data-controller="forms--device-form"
export default class extends Controller {

    static stores = [
        allDevicesStore
    ]

    connect() {
        useStore(this)

        // Get device ID from URL parameters (parameter name is 'device')
        const urlParams = new URLSearchParams(window.location.search)
        const deviceId = urlParams.get('device')

        if (deviceId) {
            // Fetch device from API in the correct format
            this.fetchDevice(deviceId)
        }
    }

    async fetchDevice(deviceId) {
        try {
            const response = await fetch(`/api/items/${ encodeURIComponent(deviceId) }`)
            if (!response.ok) {
                console.error('Failed to fetch device:', response.status)
                this.setAllDevicesStoreValue([])
                return
            }
            const data = await response.json()
            if (data.data) {
                this.setAllDevicesStoreValue([data.data])
            } else {
                this.setAllDevicesStoreValue([])
            }
        } catch (error) {
            console.error('Error fetching device:', error)
            this.setAllDevicesStoreValue([])
        }
    }
}